module.exports = __webpack_public_path__ + "img/step1.7b5521af.jpeg";